import { ExternalLink } from 'lucide-react';
import { SITE } from '../content/siteCopy';

/** Bloco de credibilidade — razão social, contatos e site institucional. */
export default function BrandTrustStrip({ className = '' }: { className?: string }) {
  return (
    <div
      className={`rounded-2xl border border-lunins-border bg-lunins-surface/80 px-5 py-4 text-xs leading-relaxed text-lunins-muted md:px-6 ${className}`}
    >
      <p className="font-medium text-lunins-ink">{SITE.footerInstitutionalLine}</p>
      <p className="mt-2">
        <strong className="text-lunins-ink">{SITE.org.razao}</strong> — CNPJ {SITE.org.cnpj}
      </p>
      <p className="mt-1">
        <a href={`mailto:${SITE.org.email}`} className="lunins-link">
          {SITE.org.email}
        </a>
        {' · '}
        <span>{SITE.org.whatsappDisplay}</span>
        {' · '}
        <a href="https://www.instagram.com/luninsbr" target="_blank" rel="noreferrer" className="lunins-link">
          {SITE.org.instagram}
        </a>
      </p>
      <p className="mt-2 flex flex-wrap items-center gap-1.5">
        <a
          href={SITE.siteInstitucionalUrl}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1 font-medium text-lunins-ink hover:text-lunins-teal"
        >
          Site institucional lunins.org
          <ExternalLink className="h-3.5 w-3.5 opacity-80" aria-hidden />
        </a>
        <span className="text-lunins-muted">— mesma marca e canais oficiais.</span>
      </p>
    </div>
  );
}
